module.exports = __webpack_public_path__ + "img/logo-tagline.138a7f5a.png";